import React, {Component} from 'react';
import {FormControl, Icon, Input, InputLabel,} from '@material-ui/core';
import {NumberInput} from "./index";

class UecareInput extends Component {

    render() {

        return (
            <div className="flex">
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>
                <FormControl className={this.props.className} fullWidth>
                    <InputLabel>{this.props.label}</InputLabel>
                    {
                        this.props.inputType === 'number' ?
                            (<NumberInput
                                id={this.props.id}
                                name={this.props.name}
                                value={this.props.value}
                                onChange={this.props.onChange}
                                disabled={this.props.disabled}/>) :
                            (<Input
                                id={this.props.id}
                                name={this.props.name}
                                value={this.props.value}
                                onChange={this.props.onChange}
                                disabled={this.props.disabled}/>)
                    }
                </FormControl>
            </div>
        );
    }
}

export default UecareInput;



// WEBPACK FOOTER //
// ./src/components/UecareInput.js